import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';

const styles = theme => ({
    profileAbout: {
        textAlign: 'center',
    },
    btnStyle: {
        marginTop: 10,
        textTransform: 'capitalize', 
        fontWeight: 'bold', 
        fontSize: 16
    }
});

class AboutToggle extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            opened: false,
        };
        this.toggleBox = this.toggleBox.bind(this);
    }
    toggleBox() {
        const { opened } = this.state;
        this.setState({
            opened: !opened,
        });
    }
  render() {
    const { classes, brandProfile, title } = this.props;
    const { opened, btnName } = this.state;
    let description = brandProfile.description;
    let descriptionLength = description.length;
    let sliceDescription = description.substr(0, 150);
    let showAllDescription = description.slice(150);

    return(
        <Grid container spacing={16} direction="row" justify="center" alignItems="center">  
            <Grid item xs={12} sm={8} md={10} className={classes.profileAbout}>
                {/* <span className={classes.profileAbout}> */}
                    <h2 style={{ margin: '10px 0px 5px'}}>
                        About {fontUniOrConvertZawgyi(brandProfile.name)}
                    </h2>
                {/* </span> */}
                <Typography component="p" variant="subtitle1" >
                    {fontUniOrConvertZawgyi(sliceDescription)}
                    {opened && fontUniOrConvertZawgyi(showAllDescription)}
                </Typography>
                {
                    descriptionLength > 150 &&
                    <Button color="primary" onClick={this.toggleBox} className={classes.btnStyle}>
                    {!opened ? 'More Info' : 'Less Info' }
                </Button>
                }
                
            </Grid>
        </Grid>
    )
  }
}

AboutToggle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AboutToggle);
